module.exports = __webpack_public_path__ + "img/movie-2.815e1621.png";